import { produce } from "immer";
import { useFlags } from "launchdarkly-react-client-sdk";
import React, { useContext, useMemo } from "react";
import shortid from "shortid";
import styled from "styled-components";

import { parseItemCanvas } from "@examspark/api";
import { Exam } from "@examspark/exam-ui";
import {
  ExamSessionMetadata,
  FeatureFlags,
  Maybe,
  ResourceContent,
} from "@examspark/types";

import { ExamEditorContext } from "../../exam-editor/examEditor";

const Styled = styled.div`
  height: 100%;
  min-height: 0;
  padding: 1rem;
  box-sizing: border-box;
`;

const produceCanvas = <
  T extends { content?: Maybe<{ canvas?: Maybe<ResourceContent["canvas"]> }> },
>(
  data: Maybe<T>,
) => {
  return produce(data, parseItemCanvas);
};
const ActivityEditorPreview = () => {
  const [state] = useContext(ExamEditorContext);

  const sessionData: ExamSessionMetadata = useMemo(
    () => ({
      shuffleSeed: shortid.generate(),
      shuffleOptions: true,
      shuffleItems: false,
    }),
    [],
  );

  const examData = useMemo(
    () => ({
      name: state.name,
      content: {
        forms: [
          {
            sections: [
              {
                questionIds: state.questions.map((q) => q.id),
              },
            ],
          },
        ],
      },
      questions: state.questions.map(produceCanvas),
    }),
    [state],
  );

  const flags =
    useFlags<
      Pick<
        FeatureFlags,
        "itemEditorAdditionalContext" | "lineReader" | "textToSpeech"
      >
    >();

  return (
    <Styled>
      <Exam
        autoStart
        examData={examData}
        sessionData={sessionData}
        // results={results}
        flags={flags}
        config={{
          showAdditionalContext: flags.itemEditorAdditionalContext,
          showScoreOnComplete: true,
        }}
        onSubmit={async (state) => {
          // console.log("scoring", exam, state.responses);
          // const score = scoreExam(examData, state.responses ?? {});
          // setResults(score);
        }}
      />
    </Styled>
  );
};

export default ActivityEditorPreview;
